import {
  StyledOptionsFooter,
  StyledSelectedFilters
} from './CategoryFilters.style';
import SettingsButton from '../../../../settings/SettingsButton';
import IssuesButton from './IssuesButton';
import { CATEGORIES_KEYS } from '../../../useCategoriesWidget/useCategoriesWidget';
import CategoryFiltersLine from './CategoryFiltersLine';

const CategoryFilters = ({ selectedCategory, toggleIssuesDisplay }) => {
  const categoryFilters = selectedCategory?.filters || [];
  const isFiltersExists = categoryFilters.length > 0;

  const isHiddenForCategories = [CATEGORIES_KEYS.POTENTIAL_SAVINGS];
  const categoriesWithoutFiltersTitle = [CATEGORIES_KEYS.OTHERS];

  if (isHiddenForCategories.includes(selectedCategory.key)) return null;

  return (
    <StyledSelectedFilters>
      <header>
        {!categoriesWithoutFiltersTitle.includes(selectedCategory.key) && (
          <>{selectedCategory.name} category is based on the following:</>
        )}

        <IssuesButton
          onClick={toggleIssuesDisplay}
          disabled={selectedCategory.fte_p === 0}
        />
      </header>

      {isFiltersExists && (
        <main>
          {categoryFilters.map((filters, idx) => (
            <CategoryFiltersLine key={idx} filters={filters} />
          ))}
        </main>
      )}

      <StyledOptionsFooter>
        {isFiltersExists && (
          <SettingsButton
            text='Edit Category'
            historyState={{ selectedCategory }}
          />
        )}
      </StyledOptionsFooter>
    </StyledSelectedFilters>
  );
};

export default CategoryFilters;
